import React, { createContext, useContext, useState, useEffect } from 'react';

interface User {
  id: string;
  name: string;
  email: string;
  username: string;
  bio: string;
  avatar?: string;
  googleId?: string;
  passwordSet?: boolean;
  isPremium?: boolean;
  isTrial?: boolean;
  trialDaysLeft?: number;
  proTrialStart?: string | null;
  theme?: string;
  socialLinks?: {
    instagram?: string;
    twitter?: string;
    youtube?: string;
    linkedin?: string;
    github?: string;
  };
  customTheme?: {
    bg?: string;
    text?: string;
    accent?: string;
    font?: string;
  };
}
interface AuthContextType {
  user: User | null;
  token: string | null;
  loading: boolean;
  loginUser: (data: any) => void;
  logoutUser: () => void;
  updateUser: (data: Partial<User>) => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser]     = useState<User | null>(null);
  const [token, setToken]   = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser  = localStorage.getItem('user');
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const loginUser = (data: any) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
  };

  const logoutUser = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    window.location.href = '/logged-out';
  };


  const updateUser = (updatedData: Partial<User>) => {
    const newUser = { ...user, ...updatedData } as User;
    localStorage.setItem('user', JSON.stringify(newUser));
    setUser(newUser);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, loginUser, logoutUser, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};